import React, {Component} from 'react';

class skill extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <span className={`p-1 m-1 inline-flex bg-${ this.props.color}-200 text-normal text-${ this.props.color}-900 cursor-pointer`}>
                {this.props.name}
            </span>
        );
    }
}

export default skill;